import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

const CARD_BASE =
  'flex items-center gap-3 px-4 py-3.5 border rounded-xl bg-white cursor-pointer transition-colors hover:border-mty-primary/40 hover:bg-mty-primary/5';
const CARD_CHECKED = 'border-mty-primary bg-mty-primary/10';
const CARD_UNCHECKED = 'border-[var(--mat-sys-outline-variant)]';

@Component({
  selector: 'app-formly-mat-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCheckboxModule, TranslateModule, FormlyModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      /* Material's checkbox ships a 40px state-layer / ripple overlay that
         draws a large circle around the 18px tick. Globally we already
         suppress ripples on buttons (see tailwind.css); checkbox uses its
         own internals, so we neutralise them here. */
      :host ::ng-deep .mat-mdc-checkbox {
        --mdc-checkbox-state-layer-size: 18px;
      }
      :host ::ng-deep .mat-mdc-checkbox .mdc-checkbox__ripple,
      :host ::ng-deep .mat-mdc-checkbox .mat-mdc-checkbox-ripple,
      :host ::ng-deep .mat-mdc-checkbox .mat-mdc-checkbox-touch-target {
        display: none !important;
      }
    `,
  ],
  template: `
    @if (props['variant'] === 'card') {
      <label [class]="cardClass()" [attr.data-field-id]="field.id">
        <mat-checkbox
          [id]="id"
          [formControl]="$any(formControl)"
          [formlyAttributes]="field"
          color="primary">
        </mat-checkbox>
        <span class="flex-1">
          <span class="block font-medium">{{ (props.label || '') | translate }}</span>
          @if (props['description']) {
            <span class="block text-sm mt-1 text-black/55">
              {{ props['description'] | translate }}
            </span>
          }
        </span>
      </label>
    } @else {
      <div [attr.data-field-id]="field.id">
        <mat-checkbox [id]="id" [formControl]="$any(formControl)" [formlyAttributes]="field" color="primary">
          {{ (props.label || '') | translate }}
        </mat-checkbox>
        @if (props['description']) {
          <p class="font-base text-[13px] text-black/55 mt-1.5 ml-9">{{ props['description'] | translate }}</p>
        }
      </div>
    }
  `,
})
export class MatCheckboxFieldComponent extends FieldType<FieldTypeConfig> {
  cardClass(): string {
    return `${CARD_BASE} ${this.formControl.value ? CARD_CHECKED : CARD_UNCHECKED}`;
  }
}
